import { cpfResponsavelValido } from '@utils';
import * as yup from 'yup';

export const dynamicRule = (type) => {
  const base = yup.mixed();

  switch (type) {
    case 'required':
      return base.required('Requerido');
    case 'excluir':
      return base.when('acao', {
        is: (acao) => acao !== 'Excluir',
        then: (field) => field.required('Requerido'),
      });
    case 'mat':
      return base.when('elegivelBeneficioMAT', {
        is: 'Sim',
        then: (field) => field.required('Requerido'),
      });
    case 'aposentado':
      return base.when('estaAposentadoINSS', {
        is: (value) => {
          return value === 'Sim';
        },
        then: (field) => field.required('Requerido'),
      });
    case 'naoAposentado':
      return base.when('estaAposentadoINSS', {
        is: (value) => {
          return value === 'Não';
        },
        then: (field) => field.required('Requerido'),
      });
    case 'cpf':
      return base.when('cpfResponsavelLegal', {
        is: (cpf) => cpfResponsavelValido(cpf),
        then: (field) => field.required('Requerido'),
      });
    case 'laudoMedico':
      return base.when('parentesco', {
        is: 'Filho(a) especial',
        then: (field) => field.required('Requerido'),
      });

    case 'laudoMedicoAdd':
      return base.when(['parentesco', 'acao'], {
        is: (parentesco, acao) =>
          (parentesco === 'Filho(a) especial' ||
            parentesco === 'Pessoa absolutamente incapaz') &&
          acao !== 'Excluir',
        then: (field) => field.required('Requerido'),
      });

    case 'laudoMedicoBeneficiarioAdd':
      return base.when(['parentesco', 'acao', 'situacaoParentesco'], {
        is: (parentesco, acao, situacao) =>
          (parentesco === 'Filho(a)' || parentesco === 'Enteado(a)') &&
          situacao === 'Com invalidez' &&
          acao !== 'Excluir',
        then: (field) => field.required('Requerido'),
      });

    case 'laudoMedicoDependenteAdd':
      return base.when(['parentesco', 'situacaoParentesco', 'acao'], {
        is: (parentesco, situacao, acao) =>
          ((parentesco === 'Filho(a)' && situacao === 'Especial') ||
            parentesco === 'Pessoa absolutamente incapaz') &&
          acao !== 'Excluir',
        then: (field) => field.required('Requerido'),
      });
    case 'naoJulgado':
      return base.when('foiJulgado', {
        is: 'Não',
        then: (field) => field.required('Requerido'),
      });
    case 'julgado':
      return base.when('foiJulgado', {
        is: 'Sim',
        then: (field) => field.required('Requerido'),
      });
    case 'revisaoJudicial':
      return base.when('revisaoProcessoJudicial', {
        is: 'Sim',
        then: (field) => field.required('Requerido'),
      });
    case 'naoRevisaoJudicial':
      return base.when('revisaoProcessoJudicial', {
        is: 'Não',
        then: (field) => field.required('Requerido'),
      });
    case 'processoJudicial':
      return base.when('houveProcessoJudicial', {
        is: 'Sim',
        then: (field) => field.required('Requerido'),
      });
    case 'estudante':
      return base.when(['parentesco', 'situacaoParentesco', 'acao'], {
        is: (parentesco, sitParentesco, acao) => {
          if (acao !== 'Excluir') {
            return (
              parentesco === 'Filho(a)' && sitParentesco === 'Universitário'
            );
          }

          return false;
        },
        then: (field) => field.required('Requerido'),
      });
    case 'pais':
      return base.when('parentesco', {
        is: (parentesco) => ['Mãe', 'Pai'].includes(parentesco),
        then: (field) => field.required('Requerido'),
      });
    case 'paisAdd':
      return base.when(['parentesco', 'acao'], {
        is: (parentesco, acao) =>
          acao !== 'Excluir' && ['Mãe', 'Pai'].includes(parentesco),
        then: (field) => field.required('Requerido'),
      });
    case 'casamento':
      return base.when('parentesco', {
        is: (parentesco) => ['Cônjuge', 'Ex-cônjuge'].includes(parentesco),
        then: (field) => field.required('Requerido'),
      });
    case 'casamentoAdd':
      return base.when(['parentesco', 'acao'], {
        is: (parentesco, acao) =>
          acao !== 'Excluir' && ['Cônjuge', 'Ex-cônjuge'].includes(parentesco),
        then: (field) => field.required('Requerido'),
      });
    case 'casamentoConjugeSogroAdd':
      return base.when(['parentesco', 'acao'], {
        is: (parentesco, acao) =>
          acao !== 'Excluir' &&
          ['Cônjuge', 'Sogro(a)', 'Genro', 'Nora'].includes(parentesco),
        then: (field) => field.required('Requerido'),
      });
    case 'nascimento':
      return base.when('parentesco', {
        is: (parentesco) =>
          ['Filho(a)', 'Filho', 'Filho(a) especial', 'Enteado(a)'].includes(
            parentesco
          ),
        then: (field) => field.required('Requerido'),
      });
    case 'nascimentoAdd':
      return base.when(['parentesco', 'acao'], {
        is: (parentesco, acao) =>
          acao !== 'Excluir' &&
          ['Filho(a)', 'Filho', 'Filho(a) especial', 'Enteado(a)'].includes(
            parentesco
          ),
        then: (field) => field.required('Requerido'),
      });
    case 'convivente':
      return base.when('parentesco', {
        is: 'Convivente',
        then: (field) => field.required('Requerido'),
      });
    case 'conviventeAdd':
      return base.when(['parentesco', 'acao'], {
        is: (parentesco, acao) =>
          parentesco === 'Convivente' && acao !== 'Excluir',
        then: (field) => field.required('Requerido'),
      });
    case 'enteado':
      return base.when('parentesco', {
        is: 'Enteado(a)',
        then: (field) => field.required('Requerido'),
      });
    case 'enteadoAdd':
      return base.when(['parentesco', 'acao'], {
        is: (parentesco, acao) =>
          parentesco === 'Enteado(a)' && acao !== 'Excluir',
        then: (field) => field.required('Requerido'),
      });
    case 'menorTutelaAdd':
      return base.when(['parentesco', 'acao'], {
        is: (parentesco, acao) =>
          acao !== 'Excluir' && parentesco === 'Menor sob tutela',
        then: (field) => field.required('Requerido'),
      });
    case 'molestia':
      return base.when('molestiaGrave', {
        is: 'Sim',
        then: (field) => field.required('Requerido'),
      });
    case 'beneficiario':
      return base.when('acao', {
        is: (value) => value !== 'Excluir',
        then: (field) => field.required('Requerido'),
      });
    case 'tempoINSS':
      return base.when('tempoContribuicaoINSS', {
        is: 'Sim',
        then: (field) => field.required('Requerido'),
      });

    case 'aposentado&processo':
      return base.when(['estaAposentadoINSS', 'anexoDecisao'], {
        is: (aposentado, anexoDecisao) => {
          return aposentado === 'Não' && !!anexoDecisao;
        },
        then: (field) => field.required('Requerido'),
      });

    case 'decisao':
      return base.when('anexoDecisao', {
        is: (decisao) => !!decisao,
        then: (field) => field.required('Requerido'),
      });

    case 'tutela':
      return base.when(
        ['estaAposentadoINSS', 'houveProcessoJudicial', 'foiJulgado'],
        {
          is: (aposentado, processo, julgado) => {
            return (
              aposentado === 'Sim' && processo === 'Sim' && julgado === 'Não'
            );
          },
          then: (field) => field.required('Requerido'),
        }
      );

    case 'tutelaAdd':
      return base.when(['parentesco', 'situacaoParentesco', 'acao'], {
        is: (parentesco, sitParentesco, acao) => {
          if (acao !== 'Excluir') {
            return (
              (['Irmão(ã)', 'Neto(a)', 'Bisneto(a)'].includes(parentesco) &&
                ['Até 21 anos', 'Especial', 'Universitário'].includes(
                  sitParentesco
                )) ||
              ['Menor assistido', 'Pessoa absolutamente incapaz'].includes(
                parentesco
              )
            );
          }
          return false;
        },
        then: (field) => field.required('Requerido'),
      });

    case 'transitoEmJulgado':
      return base.when(
        ['estaAposentadoINSS', 'houveProcessoJudicial', 'foiJulgado'],
        {
          is: (aposentado, processo, julgado) => {
            return (
              aposentado === 'Sim' && processo === 'Sim' && julgado === 'Sim'
            );
          },
          then: (field) => field.required('Requerido'),
        }
      );
    default:
      return base;
  }
};
